import React from 'react';
import './style.css';
import LoaderBar from 'components/LoaderBar';
import PropTypes from 'prop-types';

const Loader = ({ className, isBarVisible, fullScreen, loaderBarClassName }) => (
  <>
    <LoaderBar className={loaderBarClassName} isVisible={isBarVisible} />
    <div
      className={`absolute left-0 top-0 w-full flex justify-center items-center ${
        fullScreen ? 'h-screen' : 'h-full'
      }`}
      data-testid="loader"
    >
      <div className={`w-full flex justify-center ${className}`}>
        <div className="loader"></div>
      </div>
    </div>
  </>
);

Loader.defaultProps = {
  className: '',
  isBarVisible: true,
  fullScreen: true,
  loaderBarClassName: ''
};

Loader.propTypes = {
  className: PropTypes.string,
  isBarVisible: PropTypes.bool,
  fullScreen: PropTypes.bool,
  loaderBarClassName: PropTypes.string
}

export default Loader;
